// extracted by mini-css-extract-plugin
module.exports = {"item":"_2VFzJ1","content":"_1iJFdy","value":"_2w3qrg","brandColor":"zKO8UX","leftPart":"_2Gk_oO","label":"_3OgwN-","note":"_3UjMHD"};